import React from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';

import { SearchContainer } from './styles';

const Search = ({ onChange, value }) => {
  return (
    <SearchContainer>
      <Input
        allowClear
        placeholder="Search"
        prefix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)', fontSize: '20px' }} />}
        onChange={onChange}
        height={62}
        value={value}
        autoFocus
        className={`${value ? 'filled' : 'empty'}`}
      />
    </SearchContainer>
  );
};

export default Search;
